import { render, staticRenderFns } from "./StockFullCardMobile.vue?vue&type=template&id=9cc54d54&scoped=true&"
import script from "./StockFullCardMobile.vue?vue&type=script&lang=js&"
export * from "./StockFullCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./StockFullCardMobile.vue?vue&type=style&index=0&id=9cc54d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc54d54",
  null
  
)

export default component.exports